import { BrowserRouter } from "react-router-dom";

import ResultsPage from "./components/pages/ResultsPage";
import LiveIndexPage from "./components/pages/LiveIndexPage";

function App() {
  const hasRaceId = new URLSearchParams(window.location.search).has("raceId");

  return (
    <div className="App">
      <BrowserRouter>
        {hasRaceId ? <ResultsPage /> : <LiveIndexPage />}
      </BrowserRouter>
    </div>
  );
}

export default App;
